import axios from "axios";
import { Case, toCustomerCase } from "../api/dataModel";

export type CustomerEntry =
  | { token: string }
  | { shortCode: string }
  | { caseId: number; conceptId?: number };

export interface CustomerSession {
  accessToken: string;
  refreshToken: string;
}

export function customerApiBaseUrl(): string {
  const configured = process.env.REACT_APP_API_URL?.trim();
  if (configured === "/") return new URL("/", window.location.origin).href;
  const raw = configured || `https://${window.location.hostname}`;
  const url = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  return `${url.href.replace(/\/+$/, "")}/`;
}

function sessionFromResponse(value: unknown): CustomerSession {
  const session = value as CustomerSession;
  if (typeof session?.accessToken !== "string" || !session.accessToken ||
      typeof session.refreshToken !== "string" || !session.refreshToken) {
    throw new Error("Invalid customer session");
  }
  return { accessToken: session.accessToken, refreshToken: session.refreshToken };
}

export class ApiClient {
  async exchange(entry: CustomerEntry, requestUrl: string): Promise<CustomerSession> {
    const response = await axios.post<CustomerSession>(
      new URL("cases/customer/session/exchange", requestUrl).href,
      entry,
      { headers: { "Cache-Control": "no-store" } },
    );
    return sessionFromResponse(response.data);
  }

  async refresh(refreshToken: string, requestUrl: string): Promise<CustomerSession> {
    const response = await axios.post<CustomerSession>(
      new URL("cases/customer/session/refresh", requestUrl).href,
      { refreshToken },
      { headers: { "Cache-Control": "no-store" } },
    );
    return sessionFromResponse(response.data);
  }

  async getStatus(accessToken: string, requestUrl: string): Promise<Case> {
    const response = await axios.get<Case>(
      new URL("cases/customer/status", requestUrl).href,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Cache-Control": "no-store",
        },
      },
    );
    return toCustomerCase(response.data);
  }
}
